import Note from 'services/api/notes/note.class';

export default class AddNoteDialogController {
    /** @ngInject */
    constructor(DialogService, notes, thingId, NotesApi, ToastService, Loader, ErrorsService) {
        this.DialogService = DialogService;
        this.notes = notes;
        this.NotesApi = NotesApi;
        this.thingId = thingId;
        this.ToastService = ToastService;
        this.Loader = Loader;
        this.ErrorsService = ErrorsService;
        this.onInit();
    }

    onInit() {
        this.genericErrors = this.ErrorsService.getGenericErrors();
    }

    addNote() {
        if (!this.newNote.length) return;

        this.Loader.show();

        const note = new Note(this.thingId, this.newNote);

        this.NotesApi.createNote(note)
            .then((data) => {
                this.notes.push(data);

                this.newNote = '';
                this.Loader.hide();
                this.ToastService.showSimpleTranslated('comment_was_created');
                this.cancel();
            });
    }

    cancel() {
        this.DialogService.cancel();
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/notes/dialog/add-note/add-note.controller.js